export const config = {
  headers : {
    "X-requested-With" : "XMLHttpRequest"
  },
  withCredentials: true
}

export const settings = {
  url : "https://busterv2.poyashi.me/ap",
  //url : "http://localhost:8080/v2/ap",
  download : "https://download2.poyashi.me/"
}
